<div *ngIf="!searching && selectedName" class="flex items-center justify-between">
  <span class="font-medium" data-test="client-search-selected-name">{{ selectedName }}</span>

  <div class="flex-shrink-0">
    <button type="button" class="btn btn-sm btn-primary-link" (click)="startSearching()" data-test="client-search-change">
      <i class="fas fa-pen mr-1"></i><span i18n>Spremeni</span>
    </button>
    <button type="button" class="btn btn-sm btn-primary-link text-red" (click)="clearSelection()" data-test="client-search-clear">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<app-autocomplete-client
  *ngIf="searching"
  [entityGroupTypeIds]="entityGroupTypeIds"
  (selectClient)="onClientSelected($event)"
></app-autocomplete-client>
